/*
 * Copyright (c) 2019. AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import * as React from "react";
import classNames from "classnames";
import * as styles from "./Button.module.scss";
import LoadingBarIcon from "../Icons/LoadingBarIcon";

interface ButtonProps
  extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  isLoading?: boolean;
}

const defaultProps: Partial<ButtonProps> = {
  disabled: false,
  type: "button",
};

export default (receivedProps: ButtonProps) => {
  const props: ButtonProps = { ...defaultProps, ...receivedProps };
  const { children, className, isLoading, ...buttonProps } = props;
  return (
    <button className={classNames(className, styles.commonButton, "btn")} {...buttonProps}>
      {isLoading && <LoadingBarIcon />}
      {!isLoading && children}
    </button>
  );
};
